import {ReactElement, useState} from 'react'
import {Trans, withNamespaces, WithNamespaces} from 'react-i18next'
import {Button} from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import messages from '../../../../../assets/messages'
import {backendRequest} from '../../../../../common/utils/requests'
import NotificationBar from '../../../../Common/NotificationBar'
import {useStyles} from './styles'

type ResponseData = {
  url: string
}

type BrokereeAutoLoginProps = {
  accountId: number
} & WithNamespaces

function BrokereeAutoLoginBase(props: BrokereeAutoLoginProps): ReactElement {
  const {accountId, t} = props

  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const classes = useStyles()

  const handleClick = async () => {
    const newTab = window.open('about:blank', '_blank')
    if (!newTab) {
      setErrorMessage('Can\'t open popup')
      return
    }

    newTab.document.write('<h4>Please wait</h4>')

    const response = await backendRequest(`/api/v2/dashboard/accounts/${accountId}/providers/brokeree/auto-login`)

    if (response.ok) {
      const data: ResponseData = await response.json()
      newTab.location = data.url
    } else {
      const errorText = await response.text()
      // eslint-disable-next-line no-console
      console.error(`Failed to generate autologin url. Error: ${response.status} ${errorText}`)
      setErrorMessage(t(messages.somethingWrongError.i18nKey, messages.somethingWrongError.defaults))
      newTab.close()
    }
  }

  const handleNotificationClose = () => {
    setErrorMessage(null)
  }

  return (
    <>
      <Button variant="outlined" color="primary" onClick={handleClick} endIcon={<OpenInNewIcon />}>
        <Trans {...messages.brokereeAdvancedSettings} />
      </Button>
      {errorMessage != null ? (
        <NotificationBar
          classes={{notificationBox: classes.notification}}
          status="error"
          onClose={handleNotificationClose}
        >
          {errorMessage}
        </NotificationBar>
      ) : null}
    </>
  )
}

const BrokereeAutoLogin = withNamespaces()(BrokereeAutoLoginBase)
export {BrokereeAutoLogin}
